import { Injectable, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { FormsBase } from 'src/app/common-components/forms-base/forms-base';
import { containsCharactersValidator } from 'src/app/common-components/validators/contain-characters.validator';
import { DepartmentDetailForm, DepartmentDetailFormValue } from '../models/department-detail-form';
import { DepartmentDetailSaveModel } from '../models/department-detail-save.model';
import { DepartmentDetailView } from '../models/department-detail-view.model';

@Injectable()
export class DepartmentDetailFormService extends FormsBase implements OnDestroy {
   private destroyed$ = new Subject<void>();

   constructor(fb: UntypedFormBuilder, private store: Store, private action: Actions) {
      super();

      const form: DepartmentDetailForm = {
         departmentId: fb.control(null),
         name: fb.control(null, [Validators.maxLength(50), containsCharactersValidator()]),
         isActive: fb.control(null),
      };

      this.form = fb.group(form);
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   updateDepartment(department: DepartmentDetailView): void {
      if (!department) {
         return;
      }

      const formValue = {
         departmentId: department.departmentId,
         name: department.name,
      };

      this.form.patchValue(formValue);
      this.markAsUntouchedAndPristine();
   }

   getValue(departmentId: number | null): DepartmentDetailSaveModel {
      const value = this.form.value as DepartmentDetailFormValue;
      return {
         departmentId: departmentId,
         name: value.name,
         isActive: value.isActive,
      };
   }
}
